import React from 'react';

interface SidebarProps {
  collapsed: boolean;
  onToggle: () => void;
  onNavigation: (item: string) => void;
  interactionCount: number;
  appMode: 'pawco' | 'genius-dog';
}

const Sidebar: React.FC<SidebarProps> = ({
  collapsed,
  onToggle,
  onNavigation,
  interactionCount,
  appMode
}) => {
  const handleNavItemClick = (itemText: string) => {
    onNavigation(itemText);
    // Close sidebar on mobile after navigation
    if (window.innerWidth <= 768 && !collapsed) {
      onToggle();
    }
  };

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="logo-section">
          {appMode === 'genius-dog' ? (
            <>
              <div className="logo-icon genius-dog-icon">
                <i className="fas fa-brain"></i>
              </div>
              <div className="brand-info">
                <h1 className="brand-name">Genius Dog</h1>
                <span className="brand-tagline">Premium Dog Food</span>
              </div>
            </>
          ) : (
            <>
              <div className="logo-icon">
                <img src="/NewPawcoLogoMinimal.png" alt="Pawco" className="logo-icon-image" />
              </div>
              <div className="brand-info">
                <h1 className="brand-name">Pawco</h1>
                <span className="brand-tagline">Your Dog's Wellness Assistant</span>
              </div>
            </>
          )}
        </div>
        <button className="sidebar-toggle" onClick={onToggle}>
          <i className="fas fa-chevron-left"></i>
        </button>
      </div>

      <nav className="sidebar-nav">
        <div className="nav-section">
          <div className="nav-header">
            <i className="fas fa-comments"></i>
            <span>Chat Session 1</span>
          </div>
          <div className="nav-subtitle">{interactionCount} interactions</div>
        </div>

               <div className="nav-section">
                 <h3 className="section-title">Quick Actions</h3>
                 <ul className="nav-menu">
                   <li className="nav-item" onClick={() => handleNavItemClick('Canine Health Check')}>
                     <i className="fas fa-heart"></i>
                     <span>Canine Health Check</span>
                   </li>
                   <li className="nav-item" onClick={() => handleNavItemClick('Feeding Calculator')}>
                     <i className="fas fa-calculator"></i>
                     <span>Feeding Calculator</span>
                   </li>
                 </ul>
               </div>

        <div className="nav-section">
          <div className="about-content">
            <div className="preview-notice">
              <div className="preview-badge">
                <i className={`fas ${appMode === 'genius-dog' ? 'fa-brain' : 'fa-flask'}`}></i>
                <span>{appMode === 'genius-dog' ? 'Premium Line' : 'Research Preview'}</span>
              </div>
              <p>
                {appMode === 'genius-dog' 
                  ? 'Genius Dog is Pawco\'s premium line of advanced dog food products, featuring cutting-edge nutrition science and superior ingredients for exceptional canine health and performance.'
                  : 'This AI assistant is currently in research preview with real-time web search enabled. While our recommendations are based on extensive canine nutrition research and current studies, always consult with your veterinarian for specific health concerns or dietary changes.'
                }
              </p>
              <div className="preview-features">
                {appMode === 'genius-dog' ? (
                  <>
                    <div className="feature-item">
                      <i className="fas fa-check-circle"></i>
                      <span>Premium nutrition formulas</span>
                    </div>
                    <div className="feature-item">
                      <i className="fas fa-check-circle"></i>
                      <span>Advanced ingredient science</span>
                    </div>
                    <div className="feature-item">
                      <i className="fas fa-check-circle"></i>
                      <span>Superior digestibility</span>
                    </div>
                    <div className="feature-item">
                      <i className="fas fa-globe-americas"></i>
                      <span>Research-backed formulations</span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="feature-item">
                      <i className="fas fa-check-circle"></i>
                      <span>Evidence-based recommendations</span>
                    </div>
                    <div className="feature-item">
                      <i className="fas fa-check-circle"></i>
                      <span>Breed-specific analysis</span>
                    </div>
                    <div className="feature-item">
                      <i className="fas fa-check-circle"></i>
                      <span>Continuous learning</span>
                    </div>
                    <div className="feature-item">
                      <i className="fas fa-globe-americas"></i>
                      <span>Real-time web search</span>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="company-logo">
              <a
                href="https://www.mypawco.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="logo-link"
              >
                <img src="/newPawCoLogoWhite.png" alt="Pawco Foods" className="logo-image" />
                <span className="logo-subtitle">Visit our website</span>
              </a>
            </div>
          </div>
        </div>
      </nav>

      <div className="sidebar-footer">
        {collapsed && (
          <button className="expand-button" onClick={onToggle} title="Expand sidebar">
            <i className="fas fa-chevron-right"></i>
          </button>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
